import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as artistsActions from '../../store/actions/artistsActions'
import { Eveniments } from '../Eveniments'

class HomeView extends React.Component {
    render() {
        return (
            <div>
                <Eveniments.PanelTimeline {...this.props} />

                <Eveniments.Timeline {...this.props} />
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        artists: state.artists.artists,
        places: state.places.places,
        eveniments: state.eveniments.eveniments
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        artistsActions: bindActionCreators(artistsActions, dispatch)
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeView))


// WEBPACK FOOTER //
// ./src/components/views/HomeView.js